import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import classNames from 'classnames';
import collect from 'collect.js';
import { RestaurantTypes } from '../Constants';

export default function RestaurantType({ data, onChange }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:Company:AddCompanyModal' });

  const restaurantTypes = useMemo(
    () =>
      collect(RestaurantTypes)
        .values()
        .map((key) => ({
          key,
          title: t(`restaurant_types.${key}.title`),
          description: t(`restaurant_types.${key}.description`),
        }))
        .toArray(),
    [t],
  );

  return (
    <div>
      <h3 className="mb-xs">{t('restaurant_type.title')}</h3>
      <p className="mb-md text-gray-600">{t('restaurant_type.description')}</p>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-2">
        {restaurantTypes.map((item) => (
          <div
            key={item.key}
            className={classNames('p-md rounded-md border border-solid cursor-pointer bg-gray-50', {
              '!bg-brand-primary': data?.restaurant_type === item.key,
            })}
            type="button"
            onClick={() => onChange('restaurant_type', item.key)}
          >
            <h6>{item.title}</h6>
            <p className="text-gray-500 text-xs" style={{ lineHeight: 1.5 }}>
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
